import {ResponseMessages} from '@/class/http';
import {BaseDocument, BaseFilter} from '@/store/type';
import {MemberServiceType} from '@/class/service-form.interface';
import {Member, TimeInformation} from '@/store/member/member.types';
import {EntitySubService, SubService} from '@/store/subservice/subservice.types';
import {EntityTimeTransaction} from '@/store/time-transaction/time-transaction.types';


export interface ServiceTransactionInitState {
  serviceTransactions: EntityServiceTransaction[],
  serviceTransaction: EntityServiceTransaction,
  serviceTransactionHistory: EntityServiceTransaction[],
  information: InformationServiceTransaction, // service running
  rating: number,
  jobRunning: JobRunning,
  jobIsRunning: boolean,
  service: EntityServiceTransaction,
  inviteReceiver: EntityServiceTransaction[],
  inviteProvider: EntityServiceTransaction[]
  historyActivity: HistoryActivity[]
}

export class ResponseServiceTransaction extends ResponseMessages {
  public data!: ServiceTransaction[];
  public appCode!: number;

}

export enum ServiceTransactionStatus {
  Waiting = 'Waiting', // รอยืนยัน
  Deleted = 'Deleted',
  Reject = 'Reject', // ยกเลิก
  Deny = 'Deny',
  Done = 'Done', // เสร็จแล้ว
  Running = 'Running', // กำลังดำเนินการ
  Confirm = 'Confirm', // ยืนยันการเข้าร่วม
  CodeGenerated = 'Code generated', // รอการยืนยันโคด
  FinalCodeGenerated = 'Final code generated', // รอการยืนยันโคด
  Busy = 'Busy'
}

export enum ServiceRead {
  Read = 'Read',
  Unread = 'Unread',
}

export interface ServiceTransaction extends BaseDocument {
  serviceType: MemberServiceType;
  serviceDate: Date;
  serviceStartDate: Date;
  serviceEndDate: Date;
  remark: string;
  phone: string;
  memberId: string;
  inviteId: string;
  location: string;
  serviceTransactionStatus: ServiceTransactionStatus;
  subServiceId: string;
  read: ServiceRead;
  refNo: string;
  startCode: string;
  finalCode: string;
}

export interface EntityServiceTransaction extends ServiceTransaction {
  member: Member;
  invite: Member;
  subService: EntitySubService;
  timeTransaction: EntityTimeTransaction[];
}

export interface InformationServiceTransaction extends EntityServiceTransaction {
  isOwner: boolean;
  pointLeft: string;
}

export interface JobRunning extends ServiceTransaction {
  timeTransactions: TimeInformation[]
  subService: EntitySubService
}

export interface FilterServiceTransaction extends ServiceTransaction, BaseFilter {

}

export interface VerifyCodeInterface {
  startCode: string;
}

export interface VerifyCodeEndInterface {
  point: number;
  finalCode: string;
}

export interface AnswerServiceTransaction {
  id: string;
  answer: string;
}

export interface HistoryActivity {
  id:                  string;
  sd:                  Date;
  status:              string;
  point:               null;
  remain:              null;
  name:                string;
  activityPartner:    string;
  activityPartnerId:  string;
  memberId:           string;
  comId:              string;
  serviceName:        string;
  communityName:      string;
}
